module.exports = __webpack_public_path__ + "img/who-does-an-independent-agent-work-for.3d2d0449.jpg";